import { Dispatch, SetStateAction, useState } from 'react';
import { Button } from '../../../styles/GlobalComponents';

import { Box, Flexed } from '../../../styles/GlobalComponents';
import { Icon, IconSendTravelutionGift } from '../../../styles/Icons';
import { P2, P3 } from '../../../styles/FontStyles';

import { InputBackOffice } from '../../../components/common/InputBackoffice';

import { SendGiftSteps } from './Subscription.types';
import { sendGift } from '../Portfolio.actions';
import { useDispatch } from 'react-redux';

export const SendGift = ({
  giftOrder,
  setStep
}: {
  giftOrder: any;
  setStep: Dispatch<SetStateAction<SendGiftSteps>>;
}) => {
  const [id, setId] = useState('');

  const dispatch = useDispatch();

  return (
    <>
      <Flexed column center>
        <Flexed>
          <Icon mb='20'>
            <IconSendTravelutionGift />
          </Icon>
        </Flexed>
      </Flexed>

      <P2 bold center mb='20'>
        Provide the recipient's Travelution User ID
      </P2>

      <P3 mb='10' bold>
        Travelution UID:
      </P3>
      <InputBackOffice
        placeholder={'Enter UID here'}
        style={{ marginBottom: 30 }}
        value={id}
        onChange={(e: string) => setId(e)}
      />
      <Flexed between>
        <Button negative mr='10'>
          Cancel
        </Button>
        <Button
          width='150px'
          ml='10'
          onClick={() =>
            dispatch(
              sendGift({
                giftOrderId: giftOrder.id,
                recipientUserId: id,
                setStep
              })
            )
          }>
          Send
        </Button>
      </Flexed>
    </>
  );
};
